import { z } from "zod";

export const relationEntities = [
  "client",
  "employee",
  "supplier",
  "subcontractor",
  "subscription",
  "intervention",
] as const;

export const relationLinkSchema = z.object({
  entity: z.string(),
  id: z.number(),
  displayName: z.string(),
  kind: z.enum(["direct", "contact"]),
  url: z.string(),
  role: z.string().nullable().default(null),
});

export const contactRelationsSchema = z.object({
  links: z.array(relationLinkSchema).default([]),
});
